import type { ReactNode } from "react"
import { AccordionTrigger } from "@/components/reusables/ui/accordion"
import { Horizontal } from "@/components/standard/BFLayout"
import { H5 } from "@/components/standard/BFText"

export const AccordionHeader = ({
  text,
  value,
  testId,
}: {
  text: string | ReactNode
  value?: string | ReactNode
  testId?: string
}) => {
  return (
    <AccordionTrigger testID={testId}>
      <Horizontal className={"justify-between items-center flex-1 py-2"}>
        <H5 color={"primary"}>{text}</H5>
        <H5 color={"primaryLight"} className={"mr-2"}>
          {value}
        </H5>
      </Horizontal>
    </AccordionTrigger>
  )
}
